import rtlCssJS from 'rtl-css-js';

import Multitracker from 'js/app/multitrackerSingleton';
import user from 'js/lib/user';

// load common translator so we can get the locale
// of the current RequireJS context
// @see http://requirejs.org/docs/api.html#multiversion
import _t from 'i18n!nls/page';

function languageTagToName(
  // TODO: Consider strong-typing language codes
  code: string,
  options = { translated: true }
): string | undefined {
  const { translated } = options;

  switch (code) {
    case 'ab':
      return translated ? _t('Abkhaz') : 'Abkhaz';
    case 'aa':
      return translated ? _t('Afar') : 'Afar';
    case 'af':
      return translated ? _t('Afrikaans') : 'Afrikaans';
    case 'ak':
      return translated ? _t('Akan') : 'Akan';
    case 'sq':
      return translated ? _t('Albanian') : 'Albanian';
    case 'am':
      return translated ? _t('Amharic') : 'Amharic';
    case 'ar':
      return translated ? _t('Arabic') : 'Arabic';
    case 'ar-EG':
      return translated ? _t('Arabic (Egypt)') : 'Arabic (Egypt)';
    case 'an':
      return translated ? _t('Aragonese') : 'Aragonese';
    case 'hy':
      return translated ? _t('Armenian') : 'Armenian';
    case 'as':
      return translated ? _t('Assamese') : 'Assamese';
    case 'av':
      return translated ? _t('Avaric') : 'Avaric';
    case 'ae':
      return translated ? _t('Avestan') : 'Avestan';
    case 'ay':
      return translated ? _t('Aymara') : 'Aymara';
    case 'az':
      return translated ? _t('Azerbaijani') : 'Azerbaijani';
    case 'bm':
      return translated ? _t('Bambara') : 'Bambara';
    case 'ba':
      return translated ? _t('Bashkir') : 'Bashkir';
    case 'eu':
      return translated ? _t('Basque') : 'Basque';
    case 'be':
      return translated ? _t('Belarusian') : 'Belarusian';
    case 'bn':
      return translated ? _t('Bengali') : 'Bengali';
    case 'bh':
      return translated ? _t('Bihari') : 'Bihari';
    case 'bi':
      return translated ? _t('Bislama') : 'Bislama';
    case 'bs':
      return translated ? _t('Bosnian') : 'Bosnian';
    case 'br':
      return translated ? _t('Breton') : 'Breton';
    case 'bg':
      return translated ? _t('Bulgarian') : 'Bulgarian';
    case 'my':
      return translated ? _t('Burmese') : 'Burmese';
    case 'ca':
      return translated ? _t('Catalan') : 'Catalan';
    case 'ch':
      return translated ? _t('Chamorro') : 'Chamorro';
    case 'ce':
      return translated ? _t('Chechen') : 'Chechen';
    case 'ny':
      return translated ? _t('Chichewa') : 'Chichewa';
    case 'zh':
      return translated ? _t('Chinese') : 'Chinese';
    case 'zh-CN':
      return translated ? _t('Chinese (Simplified)') : 'Chinese (Simplified)';
    case 'zh-TW':
      return translated ? _t('Chinese (Traditional)') : 'Chinese (Traditional)';
    case 'cv':
      return translated ? _t('Chuvash') : 'Chuvash';
    case 'kw':
      return translated ? _t('Cornish') : 'Cornish';
    case 'co':
      return translated ? _t('Corsican') : 'Corsican';
    case 'cr':
      return translated ? _t('Cree') : 'Cree';
    case 'hr':
      return translated ? _t('Croatian') : 'Croatian';
    case 'cs':
      return translated ? _t('Czech') : 'Czech';
    case 'da':
      return translated ? _t('Danish') : 'Danish';
    case 'fa-AF':
      return translated ? _t('Dari') : 'Dari';
    case 'dv':
      return translated ? _t('Divehi') : 'Divehi';
    case 'nl':
      return translated ? _t('Dutch') : 'Dutch';
    case 'dz':
      return translated ? _t('Dzongkha') : 'Dzongkha';
    case 'en':
      return translated ? _t('English') : 'English';
    case 'en-CA':
      return translated ? _t('English (Canada)') : 'English (Canada)';
    case 'en-GB':
      return translated ? _t('English (United Kingdom)') : 'English (United Kingdom)';
    case 'en-IN':
      return translated ? _t('English (India)') : 'English (India)';
    case 'eo':
      return translated ? _t('Esperanto') : 'Esperanto';
    case 'et':
      return translated ? _t('Estonian') : 'Estonian';
    case 'ee':
      return translated ? _t('Ewe') : 'Ewe';
    case 'fo':
      return translated ? _t('Faroese') : 'Faroese';
    case 'fj':
      return translated ? _t('Fijian') : 'Fijian';
    case 'fi':
      return translated ? _t('Finnish') : 'Finnish';
    case 'fr':
      return translated ? _t('French') : 'French';
    case 'fr-CA':
      return translated ? _t('French (Canada)') : 'French (Canada)';
    case 'fr-FR':
      return translated ? _t('French (France)') : 'French (France)';
    case 'ff':
      return translated ? _t('Fula') : 'Fula';
    case 'gl':
      return translated ? _t('Galician') : 'Galician';
    case 'ka':
      return translated ? _t('Georgian') : 'Georgian';
    case 'de':
      return translated ? _t('German') : 'German';
    case 'de-DE':
      return translated ? _t('German (Germany)') : 'German (Germany)';
    case 'el':
      return translated ? _t('Greek') : 'Greek';
    case 'gn':
      return translated ? _t('Guaraní') : 'Guaraní';
    case 'gu':
      return translated ? _t('Gujarati') : 'Gujarati';
    case 'ht':
      return translated ? _t('Haitian') : 'Haitian';
    case 'ha':
      return translated ? _t('Hausa') : 'Hausa';
    case 'he':
      return translated ? _t('Hebrew') : 'Hebrew';
    case 'hz':
      return translated ? _t('Herero') : 'Herero';
    case 'hi':
      return translated ? _t('Hindi') : 'Hindi';
    case 'ho':
      return translated ? _t('Hiri Motu') : 'Hiri Motu';
    case 'hu':
      return translated ? _t('Hungarian') : 'Hungarian';
    case 'ia':
      return translated ? _t('Interlingua') : 'Interlingua';
    case 'id':
      return translated ? _t('Indonesian') : 'Indonesian';
    case 'ie':
      return translated ? _t('Interlingue') : 'Interlingue';
    case 'ga':
      return translated ? _t('Irish') : 'Irish';
    case 'ig':
      return translated ? _t('Igbo') : 'Igbo';
    case 'ik':
      return translated ? _t('Inupiaq') : 'Inupiaq';
    case 'io':
      return translated ? _t('Ido') : 'Ido';
    case 'is':
      return translated ? _t('Icelandic') : 'Icelandic';
    case 'it':
      return translated ? _t('Italian') : 'Italian';
    case 'iu':
      return translated ? _t('Inuktitut') : 'Inuktitut';
    case 'ja':
      return translated ? _t('Japanese') : 'Japanese';
    case 'jv':
      return translated ? _t('Javanese') : 'Javanese';
    case 'kl':
      return translated ? _t('Kalaallisut') : 'Kalaallisut';
    case 'kn':
      return translated ? _t('Kannada') : 'Kannada';
    case 'kr':
      return translated ? _t('Kanuri') : 'Kanuri';
    case 'ks':
      return translated ? _t('Kashmiri') : 'Kashmiri';
    case 'kk':
      return translated ? _t('Kazakh') : 'Kazakh';
    case 'km':
      return translated ? _t('Khmer') : 'Khmer';
    case 'ki':
      return translated ? _t('Kikuyu') : 'Kikuyu';
    case 'rw':
      return translated ? _t('Kinyarwanda') : 'Kinyarwanda';
    case 'ky':
      return translated ? _t('Kyrgyz') : 'Kyrgyz';
    case 'kv':
      return translated ? _t('Komi') : 'Komi';
    case 'kg':
      return translated ? _t('Kongo') : 'Kongo';
    case 'ko':
      return translated ? _t('Korean') : 'Korean';
    case 'ku':
      return translated ? _t('Kurdish') : 'Kurdish';
    case 'kj':
      return translated ? _t('Kwanyama') : 'Kwanyama';
    case 'la':
      return translated ? _t('Latin') : 'Latin';
    case 'lb':
      return translated ? _t('Luxembourgish') : 'Luxembourgish';
    case 'lg':
      return translated ? _t('Ganda') : 'Ganda';
    case 'li':
      return translated ? _t('Limburgish') : 'Limburgish';
    case 'ln':
      return translated ? _t('Lingala') : 'Lingala';
    case 'lo':
      return translated ? _t('Lao') : 'Lao';
    case 'lt':
      return translated ? _t('Lithuanian') : 'Lithuanian';
    case 'lu':
      return translated ? _t('Luba-Katanga') : 'Luba-Katanga';
    case 'lv':
      return translated ? _t('Latvian') : 'Latvian';
    case 'gv':
      return translated ? _t('Manx') : 'Manx';
    case 'mk':
      return translated ? _t('Macedonian (FYROM)') : 'Macedonian (FYROM)';
    case 'mg':
      return translated ? _t('Malagasy') : 'Malagasy';
    case 'ms':
      return translated ? _t('Malay') : 'Malay';
    case 'ml':
      return translated ? _t('Malayalam') : 'Malayalam';
    case 'mt':
      return translated ? _t('Maltese') : 'Maltese';
    case 'mi':
      return translated ? _t('Māori') : 'Māori';
    case 'mr':
      return translated ? _t('Marathi') : 'Marathi';
    case 'mh':
      return translated ? _t('Marshallese') : 'Marshallese';
    case 'mn':
      return translated ? _t('Mongolian') : 'Mongolian';
    case 'me':
      return translated ? _t('Montenegrin') : 'Montenegrin';
    case 'na':
      return translated ? _t('Nauru') : 'Nauru';
    case 'nv':
      return translated ? _t('Navajo') : 'Navajo';
    case 'nb':
      return translated ? _t('Norwegian Bokmål') : 'Norwegian Bokmål';
    case 'nd':
      return translated ? _t('North Ndebele') : 'North Ndebele';
    case 'ne':
      return translated ? _t('Nepali') : 'Nepali';
    case 'ng':
      return translated ? _t('Ndonga') : 'Ndonga';
    case 'nn':
      return translated ? _t('Norwegian Nynorsk') : 'Norwegian Nynorsk';
    case 'no':
      return translated ? _t('Norwegian') : 'Norwegian';
    case 'ii':
      return translated ? _t('Nuosu') : 'Nuosu';
    case 'nr':
      return translated ? _t('South Ndebele') : 'South Ndebele';
    case 'oc':
      return translated ? _t('Occitan') : 'Occitan';
    case 'oj':
      return translated ? _t('Ojibwe') : 'Ojibwe';
    case 'cu':
      return translated ? _t('Old Church Slavonic') : 'Old Church Slavonic';
    case 'om':
      return translated ? _t('Oromo') : 'Oromo';
    case 'or':
      return translated ? _t('Oriya') : 'Oriya';
    case 'os':
      return translated ? _t('Ossetian') : 'Ossetian';
    case 'pa':
      return translated ? _t('Panjabi') : 'Panjabi';
    case 'pi':
      return translated ? _t('Pāli') : 'Pāli';
    case 'fa':
      return translated ? _t('Persian') : 'Persian';
    case 'pl':
      return translated ? _t('Polish') : 'Polish';
    case 'ps':
      return translated ? _t('Pashto') : 'Pashto';
    case 'pt':
      return translated ? _t('Portuguese') : 'Portuguese';
    case 'pt-BR':
      return translated ? _t('Portuguese (Brazil)') : 'Portuguese (Brazil)';
    case 'pt-PT':
      return translated ? _t('Portuguese (Portugal)') : 'Portuguese (Portugal)';
    case 'qu':
      return translated ? _t('Quechua') : 'Quechua';
    case 'rm':
      return translated ? _t('Romansh') : 'Romansh';
    case 'rn':
      return translated ? _t('Kirundi') : 'Kirundi';
    case 'ro':
      return translated ? _t('Romanian') : 'Romanian';
    case 'ru':
      return translated ? _t('Russian') : 'Russian';
    case 'sa':
      return translated ? _t('Sanskrit') : 'Sanskrit';
    case 'sc':
      return translated ? _t('Sardinian') : 'Sardinian';
    case 'sd':
      return translated ? _t('Sindhi') : 'Sindhi';
    case 'se':
      return translated ? _t('Northern Sami') : 'Northern Sami';
    case 'sm':
      return translated ? _t('Samoan') : 'Samoan';
    case 'sg':
      return translated ? _t('Sango') : 'Sango';
    case 'sr':
      return translated ? _t('Serbian') : 'Serbian';
    case 'gd':
      return translated ? _t('Gaelic') : 'Gaelic';
    case 'sn':
      return translated ? _t('Shona') : 'Shona';
    case 'si':
      return translated ? _t('Sinhala') : 'Sinhala';
    case 'sk':
      return translated ? _t('Slovak') : 'Slovak';
    case 'sl':
      return translated ? _t('Slovene') : 'Slovene';
    case 'so':
      return translated ? _t('Somali') : 'Somali';
    case 'st':
      return translated ? _t('Southern Sotho') : 'Southern Sotho';
    case 'es':
      return translated ? _t('Spanish') : 'Spanish';
    case 'es-ES':
      return translated ? _t('Spanish (Spain)') : 'Spanish (Spain)';
    case 'es-MX':
      return translated ? _t('Spanish (Mexico)') : 'Spanish (Mexico)';
    case 'su':
      return translated ? _t('Sundanese') : 'Sundanese';
    case 'sw':
      return translated ? _t('Swahili') : 'Swahili';
    case 'ss':
      return translated ? _t('Swati') : 'Swati';
    case 'sv':
      return translated ? _t('Swedish') : 'Swedish';
    case 'ta':
      return translated ? _t('Tamil') : 'Tamil';
    case 'te':
      return translated ? _t('Telugu') : 'Telugu';
    case 'tg':
      return translated ? _t('Tajik') : 'Tajik';
    case 'th':
      return translated ? _t('Thai') : 'Thai';
    case 'ti':
      return translated ? _t('Tigrinya') : 'Tigrinya';
    case 'tm':
      return translated ? _t('Tetum') : 'Tetum';
    case 'bo':
      return translated ? _t('Tibetan') : 'Tibetan';
    case 'tk':
      return translated ? _t('Turkmen') : 'Turkmen';
    case 'tl':
      return translated ? _t('Tagalog') : 'Tagalog';
    case 'tn':
      return translated ? _t('Tswana') : 'Tswana';
    case 'to':
      return translated ? _t('Tonga') : 'Tonga';
    case 'tr':
      return translated ? _t('Turkish') : 'Turkish';
    case 'ts':
      return translated ? _t('Tsonga') : 'Tsonga';
    case 'tt':
      return translated ? _t('Tatar') : 'Tatar';
    case 'tw':
      return translated ? _t('Twi') : 'Twi';
    case 'ty':
      return translated ? _t('Tahitian') : 'Tahitian';
    case 'ug':
      return translated ? _t('Uighur') : 'Uighur';
    case 'uk':
      return translated ? _t('Ukrainian') : 'Ukrainian';
    case 'ur':
      return translated ? _t('Urdu') : 'Urdu';
    case 'uz':
      return translated ? _t('Uzbek') : 'Uzbek';
    case 've':
      return translated ? _t('Venda') : 'Venda';
    case 'vi':
      return translated ? _t('Vietnamese') : 'Vietnamese';
    case 'vo':
      return translated ? _t('Volapük') : 'Volapük';
    case 'wa':
      return translated ? _t('Walloon') : 'Walloon';
    case 'cy':
      return translated ? _t('Welsh') : 'Welsh';
    case 'wo':
      return translated ? _t('Wolof') : 'Wolof';
    case 'fy':
      return translated ? _t('Western Frisian') : 'Western Frisian';
    case 'xh':
      return translated ? _t('Xhosa') : 'Xhosa';
    case 'yi':
      return translated ? _t('Yiddish') : 'Yiddish';
    case 'yo':
      return translated ? _t('Yoruba') : 'Yoruba';
    case 'za':
      return translated ? _t('Zhuang') : 'Zhuang';
    case 'zu':
      return translated ? _t('Zulu') : 'Zulu';
    default:
  }
  return undefined;
}

/**
 * NOTE: below is a list of language tags we currently support as languages for courses
 * see https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/scala/org/coursera/languagecode/LanguageCode.scala
 * See TRANSCRIPTION_VENDOR_LANG_CODES for fully supported locales (we have vendor transcription for these)
 */
export const courseLanguageTags: string[] = [
  'af',
  'am',
  'ar',
  'az',
  'bg',
  'bn',
  'bs',
  'ca',
  'ny',
  'cs',
  'da',
  'de',
  'el',
  'es',
  'et',
  'eu',
  'en',
  'fa',
  'fa-AF',
  'fi',
  'fr',
  'gu',
  'he',
  'hi',
  'hr',
  'ht',
  'hu',
  'hy',
  'id',
  'it',
  'ja',
  'jv',
  'ka',
  'kk',
  'km',
  'kn',
  'ko',
  'lt',
  'lv',
  'lo',
  'mk',
  'ml',
  'mn',
  'mr',
  'ms',
  'my',
  'me',
  'ne',
  'nl',
  'no',
  'pl',
  'ps',
  'pt-BR',
  'pt-PT',
  'ro',
  'ru',
  'rw',
  'sk',
  'sl',
  'so',
  'sq',
  'sr',
  'st',
  'sv',
  'sw',
  'ta',
  'te',
  'th',
  'tl',
  'tr',
  'tm',
  'tn',
  'uk',
  'ur',
  'uz',
  'vi',
  'xh',
  'yo',
  'zh-CN',
  'zh-TW',
  'zu',
];

// English, followed by translated languages in alphabetical order
export const supportedLanguageSubdomains: string[] = [
  'en',
  'ar',
  'ar-eg',
  'de',
  'es',
  'fr',
  'id',
  'ja',
  'ko',
  'pt',
  'ru',
  'zh',
  'zh-tw',
];

// special umbrella locales ar_AR, es_LA. Push arabic and spanish locales into these ones.
const facebookSpecialCases: Record<string, string> = {
  ar: 'ar_AR',
  es: 'es_LA',
};

export const cmsSupportedLanguageSubdomains: Record<string, string> = {
  ...supportedLanguageSubdomains.reduce((acc, cur) => {
    acc[cur] = cur;
    return acc;
  }, {} as Record<string, string>),
  en: 'en-US',
  ar: 'ar-SA',
  'ar-eg': 'ar-EG',
  az: 'az',
  de: 'de-DE',
  el: 'el-GR',
  'el-GR': 'el-GR',
  fr: 'fr-FR',
  hu: 'hu-HU',
  id: 'id-ID',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  'nl-NL': 'nl-NL',
  nl: 'nl-NL',
  pl: 'pl-PL',
  'pl-PL': 'pl-PL',
  sv: 'sv-SE',
  'sv-SE': 'sv-SE',
  th: 'th-TH',
  'th-TH': 'th-TH',
  tr: 'tr-TR',
  'tr-TR': 'tr-TR',
  uz: 'uz',
  vi: 'vi-VN',
  'zh-tw': 'zh-Hant-TW',
  zh: 'zh-Hans',
};

/**
 * Convert a language code to the IETF language tag
 *
 * @param  {String} code any language code or accept-language encoding
 * @return String user's language code per IETF spec, e.g. en-US
 */
export function toIetfLanguageTag(code: string): string {
  const normalizeLanguageCode = (code || '').replace(/_/g, '-').split(/[;=,]/)[0];
  // @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  return normalizeLanguageCode.toLowerCase().replace(/(-[a-z]{1,}$)/, function (match) {
    return match.toUpperCase();
  });
}

/**
 * Get user's [IETF Language Tag](http://en.wikipedia.org/wiki/IETF_language_tag)
 * for the current user from RequireJS
 *
 * @return String user's language code per IETF spec, e.g. en-US
 */
export function getIetfLanguageTag(): string {
  try {
    return toIetfLanguageTag(_t.getLocale());
  } catch (e) {
    // in case of error, default to English and emit tracking event
    Multitracker.push(['user.language.error', { error: e }]);
    return 'en-US';
  }
}

/**
 * Shorten language codes to only contain the 2 character language codes
 * @param  {String} languageTag language tag
 * @return {String}      2 character language code (ISO-631)
 */
export function toLanguageCode(languageTag: string): string {
  // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  return toIetfLanguageTag(languageTag).split('-')[0];
}

/**
 * Get user's language code (ISO-631) from the IETF language co
 * @return {String} User's ISO-631 language code
 */
export function getLanguageCode(): string {
  return toLanguageCode(getIetfLanguageTag());
}

/**
 * Moment requires language codes to be lowercase
 * @return {String} user's language code in IETF in lowercase as required by moment
 */
export function getMomentLanguage(): string {
  const lowerCaseIetfLanguage = getIetfLanguageTag().toLowerCase();
  switch (lowerCaseIetfLanguage) {
    case 'zh':
      return 'zh-cn';
    case 'zh-tw':
      return 'zh-tw';
    case 'pt':
    case 'pt-br':
      return 'pt-br';
    case 'uz':
      return 'uz-latn';
    default:
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      return lowerCaseIetfLanguage.split('-')[0];
  }
}

/**
 * Get the locale string from the language name. E.g. en_US, zh_CN... etc
 * Intended for use with facebook integration localization.
 * As per https://developers.facebook.com/docs/internationalization, the Arabic and Spanish
 * localizations had to be coded as a special case, as facebook uses a non-standard "umbrella
 * locale" for those.
 *
 * @return {String}      locale name
 */
export function getFacebookLocaleString(): string {
  const localeString = getIetfLanguageTag().replace('-', '_');
  const localeLang = localeString.split('_')[0];
  // @ts-expect-error TS2538 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  return facebookSpecialCases[localeLang] || localeString;
}

/**
 * Get the locale string from the language name, e.g. en, es, etc.
 * This is primarily intended for use with our current CMS Contentful's APIs as its API takes in particular locale-region combinations.
 *
 * If given a locale that is not supported by Contentful or Coursera, we default to the English locale.
 */
export function getCmsLocaleString(): string {
  // Walk the IETF tag from most-specific to least-specific (e.g. zh-TW → zh)
  // because cmsSupportedLanguageSubdomains has both region-qualified entries
  // (zh-tw → zh-Hant-TW) and prefix entries (zh → zh-Hans) with different values.
  // Lowercase fallback handles inconsistent existing key casing (zh-tw vs el-GR).
  const ietfTag = getIetfLanguageTag();
  const components = ietfTag.split('-');
  for (let i = 0; i < components.length; i++) {
    const candidate = components.slice(0, components.length - i).join('-');
    const match = cmsSupportedLanguageSubdomains[candidate] ?? cmsSupportedLanguageSubdomains[candidate.toLowerCase()];
    if (match) return match;
  }

  return cmsSupportedLanguageSubdomains.en ?? 'en-US';
}

/**
 * Get the language name corresponding to a language code
 * For more specific language codes in with more components such as zh-tw,
 * this function will attempt to look up the code in decreasing order of
 * specificity, meaning chopping off components from the end 1 at a time,
 * until it either finds a name mapping and returns it, or returns the code
 * itself if there's no mapping
 * Unless specified otherwise, it returns the translated language name
 * @param  {String} code language code
 * @return {String}      language name
 */
export function languageCodeToTranslatedName(code: string, translationArgs = { translated: true }): string {
  const languageCode = toIetfLanguageTag(code);
  const components = languageCode.split('-');
  let language;
  const languageMappingExists = components.some((c, i) => {
    const codeToTest = components.slice(0, components.length - i).join('-');
    language = languageTagToName(toIetfLanguageTag(codeToTest), translationArgs);
    return !!language;
  });

  return languageMappingExists && language != null ? language : code;
}

/**
 * Get the language name corresponding to a language code
 * For more specific language codes in with more components such as zh-tw,
 * this function will attempt to look up the code in decreasing order of
 * specificity, meaning chopping off components from the end 1 at a time,
 * until it either finds a name mapping and returns it, or returns the code
 * itself if there's no mapping
 * @param  {String} code language code
 * @return {String}      language name
 */
export function languageCodeToName(code: string): string {
  return languageCodeToTranslatedName(code);
}

/**
 * Detect if a language code is a right to left language
 * @param  {String}  language language code
 * @return {Boolean}          whether the language is right to left
 */
export function isRightToLeft(language: string): boolean {
  const rightToLeftLanguages = ['ps', 'fa-af', 'ar', 'he'];
  return rightToLeftLanguages.includes(toLanguageCode(language));
}

export function langDir(language: string): 'ltr' | 'rtl' {
  return isRightToLeft(language) ? 'rtl' : 'ltr';
}

/**
 * Detect if the user is using a right to left language
 * @return {Boolean} whether the user's language is right to left
 */
export function isUserRightToLeft(): boolean {
  return isRightToLeft(getIetfLanguageTag());
}

export function getMobileBadgeLanguageCode(): string {
  const mobileBadgeLanguageCodes = ['en', 'de', 'es', 'fr', 'ja', 'ko', 'pt-br', 'ru', 'zh-cn', 'zh-tw', 'ar'];

  const languageTagLower = getIetfLanguageTag().toLowerCase();
  if (mobileBadgeLanguageCodes.includes(languageTagLower)) {
    return languageTagLower;
  }

  const languageCode = getLanguageCode();
  if (languageCode === 'pt') {
    return 'pt-br';
  } else if (languageCode === 'es') {
    return 'es';
  } else if (languageCode === 'ar') {
    return 'ar';
  } else if (languageCode === 'zh') {
    return 'zh-cn';
  } else {
    return 'en';
  }
}

/*
 * mapping taken from libs/models/src/main/scala/org/coursera/languagecode/TranscriptionVendorLanguageCode.scala
 * with manual mapping of vendor's codes back to ours (via languageCodeToTranscriptionVendorCodeMapping)
 */

const TRANSCRIPTION_VENDOR_LANG_CODES = [
  'ar',
  'zh-tw',
  'zh-cn',
  'cs',
  'da',
  'nl',
  'en',
  'fr',
  'fi',
  'de',
  'el',
  'he',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'no',
  'pl',
  'pt-br',
  'ru',
  'es',
  'sk',
  'sv',
  'th',
  'tr',
  'vi',
];

/**
 * whether the language is supported for automatic transcription by our vendors
 * @param {string} langCode
 */
export const isFullySupportedLocale = (langCode: string): boolean =>
  TRANSCRIPTION_VENDOR_LANG_CODES.includes(langCode.toLowerCase());

/**
 * get current user's locale setting when available, default to `en`
 */
export const getUserLanguageCode = (): string => {
  const userLocale = user.get().locale;

  // we don't support the region for English here
  if (!userLocale || userLocale === 'en_US') {
    return 'en';
  }

  // e.g. zh_TW, pt_BR which we do support region here
  return userLocale.replace('_', '-');
};

// make style support rtl if language is rtl
// otherwise, there's no change
export const rtlStyle = <T extends {}>(styles: T, locale: string = _t.getLocale()): T => {
  if (isRightToLeft(locale)) {
    return rtlCssJS(styles);
  } else {
    // There's no need to change anything
    return styles;
  }
};

export const getLanguageDirection = (): 'rtl' | 'ltr' => {
  return isUserRightToLeft() ? 'rtl' : 'ltr';
};

export function isRenderingRightToLeft(): boolean {
  return Boolean(isUserRightToLeft());
}

// a map of translated support page locales
export const supportPageLocale = {
  ar: 'ar',
};

export const getLanguageMatch = (language1: string, language2: string): string | null => {
  // Replace '-' with '_' so that it can be matched easily
  const [generalCode1, specificCode1] = language1.replace(/-/, '_').split(/_/);
  const [generalCode2, specificCode2] = language2.replace(/-/, '_').split(/_/);

  // Compare the general language codes
  if (generalCode1 !== generalCode2) return null;

  // When both arguments have region codes, compare them and return locale if they match
  if (specificCode1 && specificCode2) {
    return specificCode1 === specificCode2 ? `${generalCode1}_${specificCode1}` : null;
  }

  // Return the most specific code that matches
  // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  return specificCode1 && specificCode1 === specificCode2 ? `${generalCode1}_${specificCode1}` : generalCode1;
};
